import { useEffect, useRef, useState } from "react";
import Button from "../Common/Button";

export const ACCESS_TYPE_OPTIONS = ["FULL_ACCESS", "READ_WRITE", "READ_ONLY", "SUPPORT"];

export const accessTypeLabels = {
  FULL_ACCESS: "Super User",
  READ_WRITE: "Read-Write",
  READ_ONLY: "Read-Only",
  SUPPORT: "Support",
};

const AccessTypeDropdown = ({
  id,
  value,
  onSelect,
  options = ACCESS_TYPE_OPTIONS,
  labels = accessTypeLabels,
  'data-testid': dataTestId = "access-type-dropdown",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={containerRef}>
      <Button
        id={id}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        data-testid={dataTestId}
        onClick={() => setIsOpen((current) => !current)}
        className="w-full rounded-md border border-disconnected bg-white dark:darkThemeGradiantBg px-3 py-2 text-sm text-dark-grey dark:text-white shadow-sm flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-theme/40"
      >
        <span>{labels[value] || value}</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M19.92 8.95L13.4 15.47C12.63 16.24 11.37 16.24 10.6 15.47L4.08 8.95"
            className="stroke-theme"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Button>
      {isOpen && (
        <div
          role="listbox"
          className="absolute left-0 right-0 mt-2 rounded-md border border-[#D1D5DB] bg-white dark:bg-darkThemeDropdownBg dark:border-darkThemeBorder dark:shadow-darkThemeDropdownMenuShadow shadow-lg z-30 overflow-hidden"
        >
          {options.map((accessType) => (
            <Button
              key={accessType}
              role="option"
              aria-selected={value === accessType}
              data-testid={`${dataTestId}-option-${accessType}`}
              onClick={() => {
                onSelect(accessType);
                setIsOpen(false);
              }}
              className={`w-full text-left px-3 py-2 text-sm ${
                value === accessType
                  ? "bg-[#1E66D0] text-white"
                  : "text-dark-grey dark:text-white hover:bg-[#F3F4F6] dark:hover:bg-darkThemeDropdownItemBg"
              }`}
            >
              {labels[accessType]}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AccessTypeDropdown;
